import { PRODUCT_VIEW_STYLES as styles } from "../../../../components/ProductView/Common/ProductView.styles";
import { CustomToggleButtonGroup } from "../../../../SharedComponents/CustomToggleButtonGroup";
import { navigation } from "../../AIPlayground.constants";

// Static JSON data for tabs
const topLevelTabs = navigation.TOP_LEVEL_TABS;
const nestedTabs = navigation.NESTED_TABS;

export const NavigationTabs = ({
  selectedTab = "copilotchat",
  setSelectedTab,
  selectedNestedTab = "home",
  setSelectedNestedTab
}: {
  selectedTab: string;
  setSelectedTab: (selectedTab: string) => void;
  selectedNestedTab?: string;
  setSelectedNestedTab?: (selectedTab: string) => void;
}) => (
  <>
    <CustomToggleButtonGroup
      items={topLevelTabs.map((tab) => tab.headerText)}
      selected={topLevelTabs.find((tab) => tab.key === selectedTab)?.headerText}
      setSelected={(headerText) => {
        const found = topLevelTabs.find((tab) => tab.headerText === headerText);
        if (found) setSelectedTab(found.key);
      }}
      stackProps={{
        styles: styles.PRODUCT_LIST.CSS_STYLES.familyToggleButtons
      }}
      toggleButtonProps={{
        style: styles.PRODUCT_LIST.CSS_STYLES.topLevelToggleButton
      }}
    />
    {selectedTab === "kqlmode" && setSelectedNestedTab && (
      <div style={styles.PRODUCT_LIST.CSS_STYLES.nestedTabsContainer}>
        <CustomToggleButtonGroup
          items={nestedTabs.map((tab) => tab.headerText)}
          selected={nestedTabs.find((tab) => tab.key === selectedNestedTab)?.headerText}
          setSelected={(headerText) => {
            const found = nestedTabs.find((tab) => tab.headerText === headerText);
            if (found) setSelectedNestedTab(found.key);
          }}
          stackProps={{
            styles: styles.PRODUCT_LIST.CSS_STYLES.familyToggleButtons
          }}
          toggleButtonProps={{
            style: styles.PRODUCT_LIST.CSS_STYLES.nestedToggleButton
          }}
        />
      </div>
    )}
  </>
);
